module.exports = __webpack_public_path__ + "static/media/  (78).e3fb3ea4.jpg";